import React from 'react';
import Typography from '@mui/material/Typography';

export default function Drought99(props) {

	return (
    <>
      <Typography variant="h5" component="h2" sx={{ mb:2 }}>
        The 1998-1999 Drought In Vermont
      </Typography>

      <Typography  variant="subtitle2">1 February 2000</Typography>
      <p>The drought which surfaced as precipitation deficits in the fall for 1998
      intensified over the course of the summer of 1999. 
      A <a href="/vt/assets/Drought_1999/summer_1999.html" target="_blank">summer recap</a> has
      been provided by the National Weather Service at the
      Burlington International Airport.</p>

      <Typography  variant="subtitle2">September Rains...</Typography>
      <p>After a summer of record-breaking temperatures and marked precipitation
        deficits, the rainfall received in September contributed significantly
        towards recharging the various components of our landscape, including
        surface moisture, streamflow and groundwater supplies. As the growing
        season drew near to a close, much of this moisture recharge was not be of
        benefit to this year's harvest, but should help to stabilize conditions
        for next year.</p>
      <p>Most of the September's precipitation was associated with remnants of
        Hurricane Dennis (September 6-7), Tropical Storm Floyd (September 16-17)
        and several cold fronts that moved across the state during the fourth
        week. Tropical Storm Floyd was by far the largest contributor, producing
        rainfall totals of 3-6 inches (76.2-152.4 mm) in a 48-hour time frame. The
        official totals from the National Weather Service are as follows:</p>
      <p>...TROPICAL SYSTEM <b>FLOYD</b> DEPOSITS HEAVY RAIN ACROSS THE NORTH
        COUNTRY... </p>
      <p>THE FOLLOWING IS AN...UPDATED LISTING...OF <b>STORM TOTAL</b> REPORTS IN
        INCHES FROM A VARIETY OF WEATHER SPOTTERS... COOPERATIVE OBSERVERS...AND
        AUTOMATED RAIN DETECTION EQUIPMENT. </p>
      <p></p>
      <p><b>Champlain Valley </b></p>
      <center>
        <table width="50%" border="1">
          <tbody>
            <tr valign="top">
              <td>Berkshire</td>
              <td>3.50</td>
            </tr>
            <tr valign="top">
              <td>Bolton</td>
              <td>6.34</td>
            </tr>
            <tr valign="top">
              <td>Burlington</td>
              <td>4.42</td>
            </tr>
            <tr valign="top">
              <td>Chazy</td>
              <td>3.71</td>
            </tr>
            <tr valign="top">
              <td>Colchester</td>
              <td>4.31</td>
            </tr>
            <tr valign="top">
              <td>Ellensburg Depot</td>
              <td>3.85</td>
            </tr>
            <tr valign="top">
              <td>Jericho</td>
              <td>4.38</td>
            </tr>
            <tr valign="top">
              <td>Middlebury</td>
              <td>5.07</td>
            </tr>
            <tr valign="top">
              <td>New Haven Junction</td>
              <td>4.34</td>
            </tr>
            <tr valign="top">
              <td>Orwell</td>
              <td>4.20</td>
            </tr>
            <tr valign="top">
              <td>Plattsburgh</td>
              <td>4.41</td>
            </tr>
            <tr valign="top">
              <td>Salisbury</td>
              <td>5.09</td>
            </tr>
            <tr valign="top">
              <td>Schuyler Falls</td>
              <td>3.85</td>
            </tr>
            <tr valign="top">
              <td>Silver Lake</td>
              <td>5.06</td>
            </tr>
            <tr valign="top">
              <td>South Hero</td>
              <td>3.59</td>
            </tr>
            <tr valign="top">
              <td>South Lincoln</td>
              <td>6.42</td>
            </tr>
            <tr valign="top">
              <td>Underhill</td>
              <td>6.38</td>
            </tr>
            <tr valign="top">
              <td>Westford</td>
              <td>4.45</td>
            </tr>
          </tbody>
        </table>
      </center>
      <p><b>Central Vermont </b></p>
      <center>
        <table width="50%" border="1">
          <tbody>
            <tr valign="top">
              <td>Barre</td>
              <td>4.95</td>
            </tr>
            <tr valign="top">
              <td>Berlin</td>
              <td>4.98</td>
            </tr>
            <tr valign="top">
              <td>Chelsea</td>
              <td>6.11</td>
            </tr>
            <tr valign="top">
              <td>Eden</td>
              <td>4.86</td>
            </tr>
            <tr valign="top">
              <td>Irasville</td>
              <td>4.95</td>
            </tr>
            <tr valign="top">
              <td>Marshfield</td>
              <td>5.68</td>
            </tr>
            <tr valign="top">
              <td>Montpelier</td>
              <td>4.64</td>
            </tr>
            <tr valign="top">
              <td>Mount Mansfield</td>
              <td>11.38</td>
            </tr>
            <tr valign="top">
              <td>Waitsfield</td>
              <td>7.05</td>
            </tr>
          </tbody>
        </table>
      </center>
      <p><b>Northeastern Vermont</b> </p>
      <center>
        <table width="50%" border="1">
          <tbody>
            <tr valign="top">
              <td>Brownington</td>
              <td>6.56</td>
            </tr>
            <tr valign="top">
              <td>East Albany</td>
              <td>5.63</td>
            </tr>
            <tr valign="top">
              <td>Greensboro</td>
              <td>4.76</td>
            </tr>
            <tr valign="top">
              <td>Jay Peak</td>
              <td>5.77</td>
            </tr>
            <tr valign="top">
              <td>Jeffersonville</td>
              <td>6.35</td>
            </tr>
            <tr valign="top">
              <td>Newark</td>
              <td>7.21</td>
            </tr>
            <tr valign="top">
              <td>Saint Johnsbury</td>
              <td>5.49</td>
            </tr>
            <tr valign="top">
              <td>Sutton</td>
              <td>5.28</td>
            </tr>
            <tr valign="top">
              <td>West Danville</td>
              <td>5.20</td>
            </tr>
          </tbody>
        </table>
        <br wp="BR1" />
      </center>
      <p><b>Southern Vermont</b></p>
      <center>
        <table width="50%" border="1">
          <tbody>
            <tr valign="top">
              <td>Bethel</td>
              <td>5.77</td>
            </tr>
            <tr valign="top">
              <td>East Wallingford</td>
              <td>6.13</td>
            </tr>
            <tr valign="top">
              <td>Rochester</td>
              <td>5.96</td>
            </tr>
            <tr valign="top">
              <td>Woodstock</td>
              <td>6.05</td>
            </tr>
          </tbody>
        </table>
      </center>
      <p>Overall, the state received 215.4 mm (8.4 inches) during September 1999,
        which represents 246% of normal. While the tropical storm remnants and
        subsequent frontal activity of October 1999 substantially reversed the dry
        conditions, the cumulative effects of the 15-month precipitation shortage
        should continue to be monitored in light of the fact that in both November
        and December 1999, below normal precipitation amounts (73% and 43%
        statewide respectively) were again received. </p>
      <p>More information on the 1998-1999 drought (embedded links may no longer be active):</p>
      <ul>
        <li><a href="vt/assets/Drought_1999/drought_statement.html" target="_blank" rel="noopener noreferer">
            June 1999 - Initial drought statement</a></li>
        <li><a href="vt/assets/Drought_1999/drought_severe.html" target="_blank" rel="noopener noreferer">
            July 1999 - Drought update and severe weather</a></li>
        <li><a href="vt/assets/Drought_1999/drought_august.html" target="_blank" rel="noopener noreferer">
            August 1999 - Impacts of the 1998-1999 drought</a></li>
      </ul>

    </>
  )
}